import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Flex, Box, Text, Card, Button } from 'rebass/styled-components'
import styled from 'styled-components';
import { CURRENT_USER } from '../graphql/queries';
import { ICurrentUserOutput, IUser } from '../graphql/types/queries/user'
import withSession from '../lib/withSession';
import { Constants } from '../utils/Constants';
import { formatPhoneNumber } from '../utils/formatPhoneNumber';
import { useState } from 'react';

const Divider = styled(Box)`
  width: 100%;
  height: 1px;
  min-height: 1px;
  background-color: #C9C9C9;
  margin-top: 25px;
  margin-bottom: 25px;
`

const AvatarImg = styled(Flex)`
  background: #FFE3D8;
  border-radius: 50%;
  border: 10px solid #f2f5f9;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  width: 108px;
  height: 108px;
  min-width: 108px;
  margin-top: -80px;
  & > img {
    width: 108px;
  }
`;

const Container = styled(Flex)`
  padding: ${() => `${Constants.OUTLETS_PADDING_MOBILE}px`};
  padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP_MOBILE}px`};
  width: 100%;
  padding-bottom: 100px;
  
  @media screen and (min-width: 68.8125em) {
    padding: ${() => `${Constants.OUTLETS_PADDING}px`};
    padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP}px`};
    min-width: ${() => `${Constants.OUTLETS_WIDTH}px`};
  }
`

interface IProfileProps {
  session: IUser
}
interface ITarget {
  name: 'Bio' | 'Settings' | 'Forms'
  link: string
}
const Settings: React.FC<IProfileProps> = ({ session }) => {
  const navigate = useNavigate()
  const { data, client } = useQuery<ICurrentUserOutput>(CURRENT_USER)
  const [selectedTarget, setSelectedTarget] = useState<ITarget | undefined>()
  return (
    <Flex flexDirection={'column'} padding={'40px'} width={'fit-content'}>
      <Button onClick={()=>navigate('/profile')}>My Bio</Button>
      <Button mt={4} onClick={()=>navigate('/form-listing')}>My Forms</Button>
    </Flex>);
}

export default withSession(Settings)